import { UnitSearchParams } from "common/api/citajteo/dl_unit/citajteo_unit";
import InputField from "components/UI/InputField/InputField";
import { SEARCH_NAMES } from "constant/search/search";
import React from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useSearchParams } from "react-router-dom";
import styled from "styled-components";
import UnitTypeSelect from "../../UnitTypeSelect";
import GroupSelect from "components/common/dl_group/GroupSelect/GroupSelect";
import DateRange, { DateRangeValue } from "components/UI/date/DateRange";
import { formSearchParamsGet } from "./SearchUnitActivate.logic";

type SearchUnitActivateProps = {
  searchLabel: string;
  placeholder?: string;
  buttonText?: string;
  navigateToSearch?: boolean;
  defaultSearchValues: UnitSearchParams & { dateRange?: DateRangeValue };
  onSearchActivate?: () => void;
  showAdvancedSearch?: boolean;
};

const SearchUnitActivate: React.FC<SearchUnitActivateProps> = ({
  searchLabel,
  placeholder,
  buttonText,
  navigateToSearch,
  defaultSearchValues,
  onSearchActivate,
  showAdvancedSearch,
}: SearchUnitActivateProps) => {
  const { handleSubmit, reset, control } = useForm();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const sTName = SEARCH_NAMES.SEARCH_TEXT;
  const searchTextDefault = defaultSearchValues[sTName] as string;
  const uTypeDefault = defaultSearchValues[SEARCH_NAMES.U_TYPE] ?? "";
  const groupSlugDefault = defaultSearchValues[SEARCH_NAMES.GROUP_SLUG] ?? "";

  const onSubmit = async (data: any) => {
    const {
      [sTName]: searchText,
      [SEARCH_NAMES.U_TYPE]: uType,
      [SEARCH_NAMES.GROUP_SLUG]: groupSlug,
      dateRange,
    } = data;
    console.log(sTName, searchText, uType, groupSlug, dateRange);
    if (navigateToSearch) {
      const navUrl = "/search" + (searchText ? `?${sTName}=${searchText}` : "");
      navigate(navUrl);
    } else {
      const newSearchParams = formSearchParamsGet(searchParams, {
        searchText,
        uType,
        groupSlug,
        dateRange,
      });

      setSearchParams(newSearchParams);
    }

    if (onSearchActivate) {
      onSearchActivate();
    }
  };

  return (
    <div>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <div>{searchLabel}</div>
        <div>
          <InputField
            name={SEARCH_NAMES.SEARCH_TEXT}
            control={control}
            key={searchTextDefault}
            defaultValue={searchTextDefault ?? ""}
            label="ključna reč"
          />
        </div>
        {showAdvancedSearch && (
          <DivAdvancedSearch>
            <div>
              <UnitTypeSelect
                name={SEARCH_NAMES.U_TYPE}
                defaultValue={uTypeDefault as string}
                control={control}
                label="tip"
                includeEmptyValue
                emptyValueLabel="svi"
              />
            </div>
            <div>
              <GroupSelect
                name={SEARCH_NAMES.GROUP_SLUG}
                defaultValue={groupSlugDefault as string}
                control={control}
                valueByField="slug"
                label="Odrednica"
                includeEmptyValue
                emptyValueLabel="sve"
              />
            </div>
            <DateRange
              name="dateRange"
              control={control}
              defaultValue={defaultSearchValues.dateRange}
              // defaultValue={{ startDate: "2026-08-12", endDate: "2026-08-27" }}
            />
          </DivAdvancedSearch>
        )}
        <DivSubmit>
          <input type="submit" value={buttonText ?? "OK"} />
        </DivSubmit>
      </Form>
    </div>
  );
};

export const DivSubmit = styled.div`
  margin-top: 0.5rem;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const DivAdvancedSearch = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1.5rem;
  align-items: center;

  div {
    display: flex;
    align-items: center;
  }
`;

export default SearchUnitActivate;
